import { gql } from '@apollo/client';

export const fetchOrdersByOrderLineId = gql`
  query fetchOrdersByOrderLineId(
    $transactionAccountId: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    transactionAccount(id: $transactionAccountId) {
      orders(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          orderNumber
        }
      }
    }
  }
`;
